import React from "react";
import { Field } from "redux-form";

class Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formErrors: [],
            rerender: false
        };
    }

    componentDidMount() {
        if (this.props.getRerenderFunction) this.props.getRerenderFunction(() => this.setState({ rerender: !this.state.rerender }));
    }

    renderFields = () => this.props.fields.map(({ name, type, label, placeholder, autofocus }, index) => {
        if (name) {
            const error = this.state.formErrors.filter(err => err.field === name)[0];

            return (
                <div className="field" key={name}>
                    <label>{label}</label>
                    <Field type={type} name={name} component={(input) => this.renderInput(input, autofocus)} placeholder={placeholder} autoFocus={autofocus} />
                    {this.renderError(error)}
                </div>
            );

        } else {
            return (
                <div className="ui header" key={index}>
                    <div className="content">{label}</div>
                </div>
            );
        }
    });

    renderInput = ({ input, type, placeholder }, autofocus = false ) => <input {...input} type={type} placeholder={placeholder} autoFocus={autofocus} />;

    renderError = (error, isWarning = false) => {
        if (error) {
            return (
                <div className={`ui ${isWarning ? "warning" : "error"} message`}>
                    {this.renderMessageLines(error.message)}
                </div>
            );
        }
    };

    renderMessageLines = message => message.map((line, index) => <p key={index}>{line}</p>);

    onSubmit = formValues => this.props.onSubmit(formValues, this.onFormError);

    onFormError = ({ data }) => this.setState({ formErrors: data.error });

    render() {
        return (
            <React.Fragment>
                <form className="ui form error warning" onSubmit={this.props.handleSubmit(this.onSubmit)}>
                    {this.props.renderFields ? this.props.renderFields(this.props.fields, this.props.label, this.props.action, this.renderInput, this.state.formErrors, this.renderError) : this.renderFields()}
                    {this.props.renderFields ? null : <button className="ui button primary">{this.props.label}</button>}
                </form>
            </React.Fragment>
        );
    }
}

export default Form;